{
  "id": "campaign-001",
  "name": "Tidy Acre",
  "seed": "campaign:1",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": ["......", "......", "......", "......", "......", ".....S"],
  "critters": [],
  "pickups": [
    {
      "kind": "coin",
      "x": 3,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 0
    }
  ],
  "generatorVersion": 3,
  "level": 1,
  "biome": "backyard",
  "par": {
    "reel": 1050,
    "push": 910,
    "selfPropelled": 840,
    "tractor": 820,
    "zeroTurn": 595,
    "fairway": 308
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 2
    }
  }
}
